import BaseSelectroPresenter from './BaseSelectroPresenter';
import {
  type SelectroTemplates,
  type SelectroText,
} from '@aha-app/selectro-v2';
import StrategicImperativeItemTemplate from '../Templates/StrategicImperatives/StrategicImperativeItemTemplate';
import terminology from 'javascripts/terminology';

// This is the definition for the strategic imperatives SelectroPresenter,
// to use it import StrategicImperativesSelectroPresenter from SelectroPresenters/index.ts
// that file exports the singleton instance of this class.
class StrategicImperativesSelectroPresenterDefinition extends BaseSelectroPresenter {
  baseTemplates(): SelectroTemplates {
    return {
      item: StrategicImperativeItemTemplate,
    };
  }

  baseText(): SelectroText {
    return {
      searchPlaceholder: `Search by name or ${terminology('product')}`,
    };
  }
}

export default StrategicImperativesSelectroPresenterDefinition;
